
import { Link } from 'react-router-dom';

export default function UTEPHero() {
  return (
    <section className="relative">
      <div className="relative w-full h-[620px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/c93aebea74e9f40cd067da1aac6441f3.jpg"
          alt="UTEP Campus Aerial View"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-12 max-w-7xl mx-auto">
          <nav className="mb-6">
            <ol className="flex items-center space-x-2 text-sm text-white/80">
              <li>
                <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
              </li>
              <li>/</li>
              <li>
                <Link to="/guides" className="hover:text-white transition-colors cursor-pointer">Guides</Link>
              </li>
              <li>/</li>
              <li className="text-white">UTEP</li>
            </ol>
          </nav>
          <h1 className="text-5xl font-bold text-white mb-4 max-w-4xl leading-tight">
            The University of Texas at El Paso: A Cornerstone of Business &amp; Economic Growth
          </h1>
          <p className="text-xl text-white/90 max-w-3xl leading-relaxed">
            Discover how UTEP drives El Paso&apos;s economy, shapes the regional workforce, and offers world-class business, real estate, and professional programs at the U.S.–Mexico border.
          </p>
        </div>
      </div>
    </section>
  );
}
